import React, { Fragment, useState, useEffect } from 'react';
import jwtDecode from 'jwt-decode';
import { useHistory, Link } from 'react-router-dom';
import {
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper, IconButton, Dialog,
    DialogActions, DialogContent, DialogContentText,
    DialogTitle, Button
} from '@mui/material';
import {
    Delete as DeleteIcon, Edit as EditIcon, ArrowForward,
    CheckCircle as ActivateIcon, Search as SearchIcon,
    Print as PrintIcon, Info as InfoIcon
} from '@mui/icons-material';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import CopyrightIcon from '@mui/icons-material/Copyright';

function StockIn() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const history = useHistory();

    const { isAuthenticated, companyId, branchId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        fetchtableData();
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const fetchtableData = async () => {
        fetchData('StockTransferApi', `/stockIn/${companyId}/${branchId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching StockTransfer roup Details:', error);
                if (error.response && error.response.status === 401) {
                    logout();
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            });
    };

    const handleDelete = async () => {
        deleteData('StockTransferApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchtableData();
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('StockTransferApi', `${itemId}`, token)
            .then(() => {
                fetchtableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }

    const handlePrint = async (StockTransferid) => {
        // Implement print functionality
    };

    return (
        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>
            <div className='w-full mb-2 flex'>
                <h5 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Stock Transfer In</h5>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                    {showSearchInput && (
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            style={{ marginLeft: '10px', width: '200px' }}
                        />
                    )}
                </div>
            </div>
            <div className="watermark">
                <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
            </div>

            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#58A5B3' }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '3%' }}>Sl.No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '10%' }}>Bill Date</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '10%' }}>Bill Number</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '30%' }}>From Branch Name</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '10%', textAlign: 'center' }}>Amount</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '10%', textAlign: 'center' }}>Quantity</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', textAlign: 'left', width: '20%' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: '#C3E9E4' }}>
                            {filteredData.map((item,index) => (
                                <TableRow
                                    key={item.id}
                                    className={item.IsActive ? '' : 'inactiveRow'}
                                    style={{ backgroundColor: item.InputAccepted ? '#d4edda' : item.InputRejected ? '#f8d7da' : '#D9C9F7' }}

                                >
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '1px', width: '3%' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '1px', width: '10%' }}>{formatDate(item.BillDate)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '1px', width: '10%' }}>{item.BillPrefix}/S/{item.BillNumber}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '1px', width: '30%' }}>{item.ToBranchName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '1px', width: '15%', textAlign: 'center' }}>{item.GrandTotal !== undefined && item.GrandTotal !== null ? item.GrandTotal.toFixed(2) : "0.00"}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '1px', width: '15%', textAlign: 'center' }}>{item.TotalQuantity}</TableCell>

                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '20%', textAlign: 'left' }}>

                                        {/* Rejected - Approved */}
                                        {item.InputRejected ? (
                                            <>
                                                <IconButton component={Link} to={`/StockInDetail/${item.Id}`}>
                                                    <InfoIcon style={{ color: 'brown' }} />
                                                </IconButton>
                                                <span style={{ color: 'red', marginLeft: '20px', fontWeight: 'bolder' }}>Rejected</span>
                                            </>
                                        ) : item.InputAccepted ? (
                                            <>
                                                <IconButton component={Link} to={`/StockInDetail/${item.Id}`} >
                                                    <InfoIcon style={{ color: 'darkgoldenrod' }} />
                                                </IconButton>
                                                <span style={{ color: 'green', marginLeft: '20px', fontWeight: 'bolder' }}>Approved</span>
                                            </>
                                        ) : (
                                            <>
                                                <IconButton component={Link} to={`/StockInDetail/${item.Id}`}>
                                                    <InfoIcon style={{ color: 'black', border: 'black' }} />
                                                </IconButton>
                                                <span style={{ color: 'black', marginLeft: '20px', fontWeight: 'bolder' }}>Waiting For Approval</span>
                                            </>
                                        )}


                                    </TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>

                    </Table>
                </TableContainer>
            </div>
        </div>
    );
}

export default StockIn;
